<template>
    <div class="connectionContainer">
        <div class="connectionHeader">
            <div class="modal_title"> 店舗コード設定</div>
        </div>
        <div class="connectionContents">
            <div class="modal_body">
                <template v-if="createMode && selectableServices.length === 0">
                    <p class="all_registered_message">すべての店舗が登録済みです。</p>
                </template>
                <template v-else>
                <div class="modal_form">
                    <div class="modal_input">
                        <label>店舗</label>
                        <select v-model="tempo_code.service_id">
                            <option value="" disabled>店舗</option>
                            <option v-for="service in selectableServices" :value="service.id" v-bind:key="service.id">{{
                                service.name
                            }}</option>
                        </select>
                    </div>
                    <div class="modal_input">
                        <label>店舗コード</label>
                        <input type="text" placeholder="店舗コード" v-model="tempo_code.tempo_code">
                    </div>
                    <div class="modal_input">
                        <label>画面表示順</label>
                        <input type="text" placeholder="画面表示順" v-model="tempo_code.display_sort">
                    </div>
                    <template v-if="!createMode">
                        <div class="modal_input">
                            <label>一時停止</label>
                            <div class="toggle_wrap">
                                <toggle-button v-model="useFlg" :sync="true"
                                    :color="{ checked: '#02AD90', unchecked: '#ccc' }" :height="30" :width="70"
                                    :labels="{ checked: 'ON', unchecked: 'OFF' }"></toggle-button>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- 他店舗の画面表示順（確認・変更用） -->
                <div class="modal_other_sorts" v-if="otherSettings.length > 0">
                    <h4 class="other_sorts_title">他店舗の画面表示順</h4>
                    <ul class="other_sorts_list">
                        <li v-for="setting in otherSettings" :key="setting.id" class="other_sorts_item">
                            <span class="other_sorts_name">
                                【{{ setting.service.id }}】{{ setting.service.name }}
                                <span v-if="Number(setting.use_flg) === 1" class="other_sorts_stopped">停止中</span>
                            </span>
                            <input type="text" class="other_sorts_input" placeholder="画面表示順"
                                v-model="setting.display_sort">
                        </li>
                    </ul>
                </div>
                <div class="modal_submit">
                    <template v-if="createMode">
                        <Button width="100px" @click="createTempoCode">追加</Button>
                    </template>
                    <template v-else>
                        <Button width="100px" @click="updateTempoCode">更新</Button>
                    </template>
                </div>
                </template>
            </div>
        </div>
    </div>
    <!-- </div> -->
</template>

<script>

export default {
    name: 'TempoCodeSettingModal',
    props: {
        createMode: Boolean,
        tempoCodeSettingId: Number,
    },
    data() {
        return {
            tempo_code: {},
            services: {},
            //登録済みの全店舗設定（他店舗の画面表示順の確認・変更用）
            settings: [],
            //変更検知用：取得時点の display_sort（id => display_sort）
            originalSorts: {},
        }
    },
    mounted: function () {
        this.getServiceId();
        this.getTempoCodeSettings();
        if (this.tempoCodeSettingId !== null) {
            this.getTempoCode();
        }
    },
    methods: {
        //サービスIDの一覧取得
        getServiceId: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/tempoCodeSettings/service")
                .then((res) => {
                    this.services = res.data;
                    console.log(this.services);
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //登録済みの全店舗設定を取得（他店舗の画面表示順を表示・編集するため）
        getTempoCodeSettings: function () {
            this.axios.get("/api/tempoCodeSettings")
                .then((res) => {
                    this.settings = res.data;
                    const originalSorts = {};
                    this.settings.forEach((setting) => {
                        originalSorts[setting.id] = setting.display_sort;
                    });
                    this.originalSorts = originalSorts;
                }).catch(() => {
                });
        },

        //選択された店舗コード情報を取得
        getTempoCode: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/tempoCodeSettings/" + this.tempoCodeSettingId)
                .then((res) => {
                    this.tempo_code = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        createTempoCode: function () {
            this.$store.dispatch("loading", true);
            const data = {
                service_id: this.tempo_code.service_id,
                tempo_code: this.tempo_code.tempo_code,
                display_sort: this.tempo_code.display_sort,
                use_flg: 0,
            };
            this.axios.post("/api/tempoCodeSettings/", data)
                .then(() => {
                    return this.saveDisplaySorts();
                })
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        updateTempoCode: function () {
            this.$store.dispatch("loading", true);
            const data = {
                id: this.tempo_code.id,
                service_id: this.tempo_code.service_id,
                tempo_code: this.tempo_code.tempo_code,
                display_sort: this.tempo_code.display_sort,
                use_flg: this.tempo_code.use_flg,
            };
            this.axios.put("/api/tempoCodeSettings/", data)
                .then(() => {
                    return this.saveDisplaySorts();
                })
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //他店舗の画面表示順のうち、変更されたものだけを一括更新する
        saveDisplaySorts: function () {
            const display_sorts = this.otherSettings
                .filter((setting) => String(setting.display_sort) !== String(this.originalSorts[setting.id]))
                .map((setting) => ({
                    id: setting.id,
                    display_sort: setting.display_sort,
                }));

            if (display_sorts.length === 0) {
                return Promise.resolve();
            }

            return this.axios.put("/api/tempoCodeSettings/displaySort", { display_sorts });
        },
        modalClose() {
            //店舗一覧ストアを再取得し、SiteTable等の表示順をF5なしで即時反映する
            this.$store.dispatch("services/fetchShops");
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    },
    computed: {
        //プルダウンに表示する店舗の絞り込み
        //新規追加(createMode=true)：未登録の店舗のみ
        //編集(createMode=false)：編集対象の店舗を表示
        selectableServices() {
            const services = Object.values(this.services || {});
            if (this.createMode) {
                return services.filter((service) => !service.registered);
            }
            return services.filter((service) => service.id === this.tempo_code.service_id);
        },
        //編集中の店舗を除いた他店舗の設定一覧（画面表示順の確認・変更用）
        //新規追加時(tempo_code.idなし)は全件、編集時は編集対象を除外する
        otherSettings() {
            return this.settings.filter((setting) => setting.id !== this.tempo_code.id);
        },
        //use_flg(1/0)とトグルボタン(true/false)を相互変換
        useFlg: {
            get() {
                return Number(this.tempo_code.use_flg) === 1;
            },
            set(value) {
                this.$set(this.tempo_code, 'use_flg', value ? 1 : 0);
            }
        }
    },
    watch: {
    }
}
</script>

<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .all_registered_message
            padding: 48px 32px
            text-align: center
            font-size: 1.6rem
            color: $grayColor
        .modal_form
            padding: 32px
            .modal_input
                margin-bottom: 24px
                display: flex
                justify-content: start
                align-items: center 
                label:not(.vue-js-switch)
                    font-size: 1.4rem
                    width: 30%

                // トグルボタンのルートも<label>のため、上のlabel指定の影響を打ち消す
                .vue-js-switch
                    width: auto
                    margin: 0

                // 入力欄(width:100%)と同じ幅を持たせ、labelの縮み方を揃えてトグルの左端を入力欄に合わせる
                .toggle_wrap
                    width: 100%
                    display: flex
                    align-items: center

                input, select
                    border: 1px solid $grayColor
                    width: 70%
                    padding: 10px
                    text-align: left
                    width: 100%
                    font-size: 1.4rem
                    background-color: #fff
                    box-sizing: border-box
                    height: 42px
                    &:focus
                        outline: 2px solid $mainColor
        .modal_other_sorts
            padding: 0 32px 24px
            .other_sorts_title
                font-size: 1.4rem
                font-weight: 700
                color: $grayColor
                margin-bottom: 12px
                padding-bottom: 8px
                border-bottom: 1px solid #ddd
            .other_sorts_list
                max-height: 240px
                overflow-y: auto
            .other_sorts_item
                display: flex
                justify-content: space-between
                align-items: center
                padding: 8px 0
                border-bottom: 1px solid #f0f0f0
                .other_sorts_name
                    font-size: 1.3rem
                    color: $grayColor
                    .other_sorts_stopped
                        color: #ff5252
                        margin-left: 8px
                .other_sorts_input
                    border: 1px solid $grayColor
                    width: 90px
                    padding: 6px 10px
                    text-align: left
                    font-size: 1.3rem
                    background-color: #fff
                    box-sizing: border-box
                    height: 36px
                    &:focus
                        outline: 2px solid $mainColor
        .modal_submit
            display: flex
            justify-content: center
    .modal_delete
        padding: 24px
        p
            font-size: 1.6rem
        .delete_btns
            margin-top: 40px
            display: flex
            justify-content: space-evenly
        
    .connectionFooter
        display: flex
        justify-content: start
</style>
